import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://wrgmicftdykgaygbnkqn.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndyZ21pY2Z0ZHlrZ2F5Z2Jua3FuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU2MDIzNTYsImV4cCI6MjA4MTE3ODM1Nn0.CpRdUWBAti0qGCLKIZCaydk4h4Nnifx6apBEwy0k4E8'

// Track if we're currently refreshing to prevent loops
let isRefreshing = false;
let refreshPromise = null;

// Custom fetch with timeout to prevent hanging requests
const fetchWithTimeout = (url, options = {}) => {
  const timeout = 20000; // 20 second timeout
  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    console.warn('[Supabase] Request timeout, aborting:', url);
    controller.abort();
  }, timeout);

  return fetch(url, {
    ...options,
    signal: controller.signal,
  }).finally(() => {
    clearTimeout(timeoutId);
  });
};

// Create client with session management
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storage: window.localStorage,
  },
  db: {
    schema: 'public',
  },
  global: {
    headers: {
      'x-client-info': 'workvan',
    },
    fetch: fetchWithTimeout,
  },
})

// Helper to safely refresh session with debouncing
// Exported so components can use this instead of calling refreshSession directly
export const safeRefreshSession = async () => {
  if (isRefreshing) {
    return refreshPromise;
  }
  
  isRefreshing = true;
  refreshPromise = supabase.auth.refreshSession()
    .then(({ data, error }) => {
      if (error) {
        // Silent fail - don't break the app
        console.warn('[Supabase] Session refresh failed:', error.message);
      }
      return { data, error };
    })
    .finally(() => {
      isRefreshing = false;
      refreshPromise = null;
    });
  
  return refreshPromise;
};

// Keep session alive by refreshing every 3 minutes (more aggressive)
setInterval(async () => {
  try {
    const { data, error } = await supabase.auth.getSession();
    if (data?.session && !error) {
      await safeRefreshSession();
    }
  } catch (e) {
    // Silently ignore refresh errors — session will recover on next attempt
  }
}, 3 * 60 * 1000);

// Immediately refresh session when tab/app becomes visible after sleep or background
// setInterval is suspended during sleep, so this catches the gap
let lastVisibilityRefresh = Date.now();
document.addEventListener('visibilitychange', async () => {
  if (document.visibilityState === 'visible') {
    const now = Date.now();
    // Only refresh if it's been more than 15 seconds since last check (more aggressive)
    if (now - lastVisibilityRefresh > 15000) {
      lastVisibilityRefresh = now;
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (session) {
          await safeRefreshSession();
        }
      } catch (e) {
        // no-op
      }
    }
  }
});

// NOTE: Do NOT register onAuthStateChange here — it must be in App.js only.
// Supabase v2 emits INITIAL_SESSION only to the FIRST registered listener.
// Having a listener here would consume INITIAL_SESSION before App.js sees it.


